import React , { useEffect , useContext , useState } from "react"; 
import {useParams} from "react-router-dom"; 
import { Button } from 'primereact/button'; 
import {LoginService} from '../../shared/services/LoginService'; 
import AppContext from '../../shared/components/AppContext';
import { ErrorParse } from "../handlers/ErrorParse";
import { useTranslation } from 'react-i18next';


// Valid Active User 
// Uses navigation survey or message error
export default function ValidActive() {

    const myContext = useContext(AppContext);  
    const { iduser , role , idotp } = useParams();

    const [formatResponse, setformatResponse] = useState({ code : 0 , tittle : '' , body : '' });
    const [isError, setIsError] = useState(false);
    const { t } = useTranslation();
    useEffect(() => {
        LoginService(myContext).Register(iduser , role , idotp).then(response => {
            if ( response.status ===  200 ) {
                myContext.setApplyApiKey(response.data.token , true).then(response => { 
                    myContext.notify6('success' , t('NOTIFICATIONS.TITLE_SUCCESS') , t('NOTIFICATIONS.DESCRIPTION_ACCOUNT_ACTIVE'));
                });  
            }
        }).catch(error => {
            let code = 400;
            if (error.response) {
               code = error.response.status;
            }
            setformatResponse({code : code , tittle : 'Error' , body : ErrorParse(error)  });
            myContext.notify6('alert' , 'Error' , ErrorParse(error) ); 
            setIsError(true);
        });   
        // eslint-disable-next-line react-hooks/exhaustive-deps      
    }, []);

    return (
        <div className="surface-section px-4 py-8 md:px-6 lg:px-8">
            <div style={{ background: 'radial-gradient(50% 109137.91% at 50% 50%, rgba(233, 30, 99, 0.1) 0%, rgba(254, 244, 247, 0) 100%)' }} className="text-center">
                <span className="bg-white text-pink-500 font-bold text-2xl inline-block px-3">{formatResponse.code}</span>
            </div>
            <div className="mt-6 mb-5 font-bold text-6xl text-900 text-center">{formatResponse.tittle}</div>
            <p className="text-700 text-3xl mt-0 mb-6 text-center">{formatResponse.body}</p>
            <div className="text-center"> 
                {isError ??  <Button label={t('VALID_ACTIVE_LABEL')} icon="pi pi-home" /> }
            </div>
        </div>
    );
}
